import { render, staticRenderFns } from "./RechargePrepaidMb.vue?vue&type=template&id=3833824e&scoped=true&"
import script from "./RechargePrepaidMb.vue?vue&type=script&lang=js&"
export * from "./RechargePrepaidMb.vue?vue&type=script&lang=js&"
import style0 from "./RechargePrepaidMb.vue?vue&type=style&index=0&id=3833824e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833824e",
  null
  
)

export default component.exports